__turbopack_context__.v({
  "card": "PlpProductCard-module-scss-module__lW06jq__card",
  "card__body": "PlpProductCard-module-scss-module__lW06jq__card__body",
  "card__cta": "PlpProductCard-module-scss-module__lW06jq__card__cta",
  "card__image": "PlpProductCard-module-scss-module__lW06jq__card__image",
  "card__image-link": "PlpProductCard-module-scss-module__lW06jq__card__image-link",
  "card__title": "PlpProductCard-module-scss-module__lW06jq__card__title",
});
